module.exports = __webpack_public_path__ + "static/media/43_A.012f3820.png";